// Public /invoice/:invoiceId/view — no auth, no nav, no CRM chrome. An
// adjuster opens this from the emailed invoice, reads it, and prints or saves
// it as a PDF. The markup is the backend's print template verbatim, so what
// they print is what Ray approves in the browser.
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export default function ViewInvoice() {
  const { invoiceId } = useParams();
  const [html, setHtml] = useState("");
  const [err, setErr] = useState("");

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${BACKEND}/api/public/invoices/${invoiceId}/html`, {
          responseType: "text",
          transformResponse: [(d) => d],
        });
        setHtml(data);
      } catch (e) {
        setErr(e?.response?.status === 404
          ? "This invoice link is not valid. Please ask for a new one."
          : "Could not load this invoice. Please try again in a moment.");
      }
    })();
  }, [invoiceId]);

  useEffect(() => {
    document.title = "Invoice";
  }, []);

  return (
    <div style={{ minHeight: "100vh", background: "#fff" }} data-testid="view-invoice-page">
      {/* The template's own sheet sets @page letter; this only hides the bar. */}
      <style>{"@media print { .no-print { display: none !important; } }"}</style>

      <div
        className="no-print"
        style={{
          display: "flex", alignItems: "center", justifyContent: "space-between", gap: 16,
          padding: "14px 20px", borderBottom: "1px solid #e5e5e5", background: "#fafafa",
          fontFamily: "'Helvetica Neue',Arial,sans-serif",
        }}
      >
        <span style={{ fontSize: 12, letterSpacing: "0.14em", textTransform: "uppercase", color: "#888" }}>
          Invoice
        </span>
        <button
          type="button"
          onClick={() => window.print()}
          disabled={!html}
          style={{
            height: 40, padding: "0 20px", border: 0, borderRadius: 6, cursor: html ? "pointer" : "default",
            background: html ? "#111" : "#bbb", color: "#fff", fontSize: 14, fontWeight: 600,
            fontFamily: "'Helvetica Neue',Arial,sans-serif",
          }}
          data-testid="print-invoice-button"
        >
          Print / Save as PDF
        </button>
      </div>

      {err && (
        <div style={{ padding: 40, textAlign: "center", color: "#b42318", fontSize: 14, fontFamily: "'Helvetica Neue',Arial,sans-serif" }}
          data-testid="view-invoice-error">
          {err}
        </div>
      )}
      {!err && !html && (
        <div style={{ padding: 40, textAlign: "center", color: "#888", fontSize: 14, fontFamily: "'Helvetica Neue',Arial,sans-serif" }}
          data-testid="view-invoice-loading">
          Loading invoice…
        </div>
      )}
      {html && <div data-testid="view-invoice-body" dangerouslySetInnerHTML={{ __html: html }} />}
    </div>
  );
}
